import { getNetworkedMicState } from "./networked-mic-state";

export const getMicrophonePresences = (() => {
  const microphonePresences = new Map();
  const sessionIds = [];
  const currentSessionIds = [];
  return function () {
    if (!window.APP || !window.APP.componentRegistry) {
      return null;
    }

    currentSessionIds.length = 0;

    const playerInfos = window.APP.componentRegistry["player-info"];
    if (playerInfos) {
      for (let i = 0; i < playerInfos.length; i++) {
        const playerInfo = playerInfos[i];
        const playerSessionId = playerInfo.playerSessionId;
        const networkedMicState = getNetworkedMicState(playerSessionId);
        const muted = typeof networkedMicState?.muted === "boolean" ? networkedMicState.muted : playerInfo.data.muted;
        if (sessionIds.indexOf(playerSessionId) === -1) {
          sessionIds.push(playerSessionId);
        }
        currentSessionIds.push(playerSessionId);
        if (microphonePresences.has(playerSessionId)) {
          const presence = microphonePresences.get(playerSessionId);
          presence.muted = muted;
        } else {
          microphonePresences.set(playerSessionId, { muted });
        }
      }
    }

    for (let i = sessionIds.length - 1; i >= 0; i--) {
      const sessionId = sessionIds[i];
      if (currentSessionIds.indexOf(sessionId) === -1) {
        microphonePresences.delete(sessionId);
        sessionIds.splice(i, 1);
      }
    }

    return microphonePresences;
  };
})();
